/**
 * constants/assetClassData.ts
 * Preset asset class options for user-facing UI components
 *
 * Provides structured asset class options for account setup and filtering.
 * Used across onboarding and account management flows.
 *
 * **NOTE**: This module provides UI-ready preset lists (e.g., `PERSONAL_ASSET_CLASSES`).
 * For domain constants, validation maps, and display formatters, see `constants/assetClass.ts`.
 */

// Internal absolute imports
import type { AssetClassOption } from '@/types/reference/PropFirmCatalog';

/**
 * Asset class definitions for personal accounts (all asset classes)
 */
export const PERSONAL_ASSET_CLASSES: AssetClassOption[] = [
  {
    id: 'futures',
    name: 'Futures',
    description: ''
  },
  {
    id: 'forex',
    name: 'Forex',
    description: ''
  },
  {
    id: 'cfd',
    name: 'CFD',
    description: ''
  },
  {
    id: 'stocks',
    name: 'Stocks',
    description: ''
  },
  {
    id: 'crypto',
    name: 'Crypto',
    description: ''
  },
  {
    id: 'options',
    name: 'Options',
    description: ''
  },
  {
    id: 'bonds',
    name: 'Bonds',
    description: ''
  },
  {
    id: 'funds',
    name: 'Funds',
    description: ''
  }
];

